module.exports = __webpack_public_path__ + "static/vrbo-c02467665eee8f268e37ce18dedbf02a.png";